import { Navigate } from 'react-router-dom';

import { ROUTES } from '@/shared/constants/routes';

export const HomePage = () => <Navigate to={ROUTES.restaurant('1')} replace />;
